import { parseCardsForFeature } from '@/assets/scripts/parsers/cards'

/** returns Accounts Balances
@return { Array }
*/
export const getCards = state => {
    return parseCardsForFeature(state.cardsList).map(card => {
        return {
            ...card,
            cardBalance: card.balance,
            cardCurrency: card.currency,
            productName: card.product,
            cardDescription: (card.additionalInfoCardView && card.additionalInfoCardView.friendlyName) ? card.additionalInfoCardView.friendlyName : null
        }
    })
}
